<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t('delete-confirmation-title') }}
      </v-card-title>

      <v-card-text class="pt-4">
        <p class="mb-3">
          {{ confirmationMessage }}
        </p>

        <v-alert type="warning" dense outlined class="mb-3">
          {{ $t('delete-confirmation-warning') }}
        </v-alert>

        <div class="mb-3">
          <strong>{{ $t('delete-confirmation-your-login-id') }}:</strong>
          <v-chip class="ml-2" color="primary" outlined>
            {{ userLoginId }}
          </v-chip>
        </div>

        <v-text-field
          v-model="typedLoginId"
          :label="$t('delete-confirmation-type-login-id')"
          outlined
          dense
          :error-messages="errorMessage"
          @input="errorMessage = ''"
        ></v-text-field>

        <p class="caption grey--text">
          {{ $t('delete-confirmation-instruction') }}
        </p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="handleCancel"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          color="error"
          :disabled="!isConfirmEnabled"
          @click="handleConfirm"
        >
          {{ $t('confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LoggerService from '../../services/logger';

export default {
  name: 'DeleteConfirmationDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    resourceType: {
      type: String,
      required: true
    },
    resourceIdentifier: {
      type: [String, Array],
      required: true
    },
    resourceName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      typedLoginId: '',
      errorMessage: ''
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    userLoginId() {
      return this.$store.getters['user/getUsername'] || localStorage.getItem('userEmail') || 'unknown';
    },
    isConfirmEnabled() {
      return this.typedLoginId.trim() === this.userLoginId;
    },
    confirmationMessage() {
      if (this.resourceName) {
        return this.$t('delete-confirmation-message-with-name', {
          type: this.$t(`delete-resource-type-${this.resourceType}`),
          name: this.resourceName
        });
      }
      
      const count = Array.isArray(this.resourceIdentifier) ? this.resourceIdentifier.length : 1;
      if (count > 1) {
        return this.$t('delete-confirmation-message-multiple', {
          count: count,
          type: this.$t(`delete-resource-type-${this.resourceType}-plural`)
        });
      }
      
      return this.$t('delete-confirmation-message-single', {
        type: this.$t(`delete-resource-type-${this.resourceType}`)
      });
    }
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.typedLoginId = '';
        this.errorMessage = '';
      }
    }
  },
  methods: {
    handleConfirm() {
      if (!this.isConfirmEnabled) {
        this.errorMessage = this.$t('delete-confirmation-login-id-mismatch');
        return;
      }

      this.logDeleteAction('CONFIRMED');
      this.$emit('confirm');
      this.dialog = false;
    },
    handleCancel() {
      this.logDeleteAction('CANCELLED');
      this.$emit('cancel');
      this.dialog = false;
    },
    logDeleteAction(status) {
      const logData = {
        action: 'DELETE_CONFIRMATION',
        status: status,
        userLoginId: this.userLoginId,
        resourceType: this.resourceType,
        resourceIdentifier: this.resourceIdentifier,
        resourceName: this.resourceName || null,
        timestamp: new Date().toISOString()
      };

      console.log(`[DELETE_CONFIRMATION] ${status}:`, logData);

      LoggerService.logDeleteConfirmation(logData);
    }
  }
};
</script>

<style scoped>
.v-card__title {
  word-break: break-word;
}
</style>
